module.exports = (__parcel__import__("6txOq")).then(() => parcelRequire('g36Vt'));